import React, { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Gheader } from './Gheader';
import styles from './Room.module.css';
import RoomButton from './RoomButton';
import RoomTable from './RoomTable';
import RoomModal from './RoomModal';
import apiService from '../api/apiService';
import { ToastContainer } from 'react-toastify';

export const Room = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState();
  const [rooms, setRooms] = useState([]);
  const hotelId = localStorage.getItem('hotel');
  const role = localStorage.getItem('role');

  useEffect(() => {
    fetchRooms();
  }, []);

  const fetchRooms = async () => {
    try {
      const response = await apiService.get(
        `/rooms/?hotel=${localStorage.getItem('hotel')}`
      );
      setRooms(response);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddRoom = newRoom => {
    setRooms([...rooms, newRoom]);
  };

  const handleEdit = updatedItem => {
    setRooms(prevData =>
      prevData.map(item => (item.id === updatedItem.id ? updatedItem : item))
    );
    setIsModalOpen(false);
    setEditingItem(null);
  };

  const handleEditClick = item => {
    setEditingItem(item);
    setIsModalOpen(true);
  };

  return (
    <div className={styles.gheader}>
      <div className={styles.dashboardContainer}>
        <Sidebar />
        <div className={styles.mainContent}>
          <Gheader />
          <h3 className="ps-2 ps-md-0">Rooms</h3>

          <div className={`${styles.buttonContainer} ps-2 ps-md-0`}>
            <RoomButton rooms={rooms} />
            {!role && (
              <button
                className={styles.addRoomButton}
                onClick={() => setIsModalOpen(true)}
              >
                Add room
              </button>
            )}
          </div>

          <RoomTable
            rooms={rooms}
            setRooms={setRooms}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            handleEditClick={handleEditClick}
            hotelId={hotelId}
            role={role}
          />
        </div>
      </div>

      <RoomModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleAddRoom}
        onEdit={handleEdit}
        hotelId={hotelId}
        existingItem={editingItem}
        role={role}
      />

      <ToastContainer autoClose={1500} />
    </div>
  );
};

export default Room;
